import type { ItemCardModel } from '@/types/ItemCardModel';
import type { TypedActionWithPayload } from '@/types/redux';

export const LOAD_SIMILAR_SOLD_ITEMS_FAIL = 'LOAD_SIMILAR_SOLD_ITEMS_FAIL';
export const LOAD_SIMILAR_SOLD_ITEMS_REQUEST = 'LOAD_SIMILAR_SOLD_ITEMS_REQUEST';
export const LOAD_SIMILAR_SOLD_ITEMS_SUCCESS = 'LOAD_SIMILAR_SOLD_ITEMS_SUCCESS';

export type LOAD_SIMILAR_SOLD_ITEMS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_SIMILAR_SOLD_ITEMS_SUCCESS,
    ItemCardModel[],
    {
        actionTime: number;
        currentPage: number;
        itemId: number;
        totalPages: number;
    }
>;
